export default function Base64UploadAdapterPlugin(editor: any) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader: any) => {
        return new Base64UploadAdapter(loader);
    };
}

class Base64UploadAdapter {
    loader: any;

    constructor(loader: any) {
        this.loader = loader;
    }

    upload() {
        return this.loader.file.then((file: File) => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve({ default: reader.result });
                reader.onerror = (error) => reject(error);
                reader.readAsDataURL(file);
            });
        });
    }

    abort() {
        // No-op for base64
    }
}